import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const SubHeader = ({ crumb }) => (
  <header className="fixed top-0 left-0 right-0 z-50 border-b border-[#0B3C5C]/10 bg-white/85 backdrop-blur-xl">
    <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
      <Link to="/" data-testid="subheader-logo" className="flex items-center gap-4">
        <img src="/logo.png" alt="Healthcare Solutions" className="h-11 w-auto" />
        {crumb && (
          <span className="font-mono-x border-l border-[#0B3C5C]/15 pl-4 text-[10px] uppercase tracking-[0.25em] text-[#4C8F2F]">
            {crumb}
          </span>
        )}
      </Link>
      <Link
        to="/"
        data-testid="subheader-back-home"
        className="inline-flex items-center gap-2 rounded-full border border-[#0B3C5C]/15 px-5 py-2.5 text-xs font-semibold text-[#33586F] transition-all duration-300 hover:border-[#5FA832] hover:text-[#5FA832]"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        Back to Home
      </Link>
    </div>
  </header>
);
